import { createAsyncAction } from "typesafe-actions";
import { IError } from "..";
import { ICupDetailData } from "./types";

export const fetchEntryCupDetail = createAsyncAction(
  "FETCH_ENTRY_CUP_DETAIL_START",
  "FETCH_ENTRY_CUP_DETAIL_SUCCESS",
  "FETCH_ENTRY_CUP_DETAIL_FAILURE",
)<void, { id: number; data: ICupDetailData }, IError>();
